<script setup lang="ts">
import { DgrToggleButton } from '@stockmarkteam/donguri-ui';

const computedIsEntertainmentFilter = defineModel<boolean>({ required: true });
</script>

<template>
  <div class="entertainment-filter">
    <span class="c-title-bold--s">エンタメ記事フィルタ</span>

    <DgrToggleButton
      class="toggle"
      v-model="computedIsEntertainmentFilter"
    ></DgrToggleButton>
  </div>
</template>

<style scoped lang="scss">
.entertainment-filter {
  border-top: solid 1px $color-gray400;
  padding: 17px 16px 0;
  margin: 0 0 17px 0;

  .toggle {
    margin-top: 12px;
  }
}
</style>
